<template>
    <div>
        <div class="form-group">
            <label>URL</label>
            <input type="text" class="form-control" v-model="data.url">
        </div>
        <div class="form-group">
            <label>API Key</label>
            <input type="text" class="form-control" v-model="data.api_key">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {};
    }
}
</script>
